export const switchViewMode = option => {
    const container = option.closest('[data-view-mode]');
    const mode      = option.dataset.viewModeOption;

    container.dataset.viewMode = mode;

    container.querySelectorAll('[data-view-mode-option]').forEach(sibling => {
        sibling.setAttribute('aria-pressed', String(sibling.dataset.viewModeOption === mode));
    });
};
